<template>
    <div>
        <form class="form" :class="{ opacity: loading === true }" @submit.prevent="postComment()">
            <label>Name</label>
            <input type="text" v-model="addComment.author_name" required="true" disabled>
            <label>E-mail</label>
            <input type="email" v-model="addComment.author_email" required="true" disabled>
            <label>Message</label>
            <textarea v-model="addComment.content" required="true" cols="50" rows="4"></textarea>
            <button class="form__btn" type="submit">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"  />
                    <path d="M0 0h24v24H0z" fill="none"/>
                </svg>
            </button>

            <div class="loading" v-show="loading">
                <loading-wheel />
            </div>
        </form>

    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            addComment: {
                author_name: rtwp.currentUser.data.display_name,
                author_email: rtwp.currentUser.data.user_email,
                content: ''
            },
        }
    },
    props: {
        comment: Object,
        post: Object
    },
    mounted() {
        if (!this.addComment.author_name) {
           let inputs = document.querySelectorAll('input');
           inputs.forEach(input => input.removeAttribute('disabled'));
        }
    },
    methods: {
        postComment() {

            var params;

            if (!this.$parent.comment) {
                params = {
                    ...this.addComment,
                    post: this.post.id
                }
            } else {
                params = {
                    ...this.addComment,
                    post: this.$parent.comment.post,
                    parent: this.$parent.comment.id
                }
            }

            this.loading = true;

            this.$store.dispatch('postComment', params).then(res => {

                let commentPost = this.$parent.$parent; 
                let commentContainer = this.$parent;

                this.$parent.comment === undefined ? commentContainer.getComments() : commentPost.getThreadComments();

                setTimeout(() => this.loading = false, 1800);

                commentPost.showCommentForm();

            }).catch(err => {
                console.error(err);
            });

        },

    }

}
</script>

<style lang="scss" scoped> 
@import '../../scss/settings';

    .form {
        display: flex;
        flex-direction: column;
        position: relative;
        min-height: rem-calc(250);

        > textarea {
            padding-right: 10%;
            min-height: rem-calc(100);
            position: relative;
        }

         &__btn {
            background: transparent;
            bottom: 0;
            border: none;
            padding: .5rem;
            position: absolute;
            right: 0;
            @extend %center-content;

            &:hover {
                cursor: pointer;
            }
        }

        > .loading {
            @extend %center-content;
            max-width: rem-calc(400);
            min-height: inherit;
            position: absolute;
            width: 100%;
        }

    }

    .opacity {
        > input, textarea, label {
            opacity: .35;
        }
    }

</style>